import { useEffect } from "react"

import SavedIcon from "@/assets/img/profile/saved.svg?react"

interface SavedToastProps {
  onDone: () => void
}

/** Auto-dismissing "Profile updated" toast. Ported from ProfileV4 SavedToast. */
export function SavedToast({ onDone }: SavedToastProps) {
  useEffect(() => {
    const timer = window.setTimeout(onDone, 2500)
    return () => window.clearTimeout(timer)
  }, [onDone])

  return (
    <div className="fixed left-1/2 top-0 z-[1200] w-full max-w-app -translate-x-1/2 p-4">
      <div className="flex animate-in items-center gap-3 rounded-2xl border-2 border-green bg-dark-surface p-3 shadow-[0_0_20px_0_#7FE718] slide-in-from-top [&_svg]:size-12">
        <SavedIcon />
        <div>
          <p className="font-body text-base font-semibold text-purple-light">Profile updated</p>
          <p className="font-body text-xs text-purple-light/70">
            Your information was saved successfully
          </p>
        </div>
      </div>
    </div>
  )
}
